
import invitationAndEarn from '~/mixins/common/pages/invite-and-earn'
export default {
    name: 'RegisterPlayerByAgent',
    mixins: [invitationAndEarn],
}
